import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38bba665"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-stretch justify-between space-x-4 font-gotham pb-3 pt-1" }
const _hoisted_2 = { class: "bg-white relative border rounded-lg font-gotham p-4" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center space-x-4" }
const _hoisted_5 = { class: "flex items-center justify-end text-sm font-semibold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
  })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
}
const _hoisted_8 = {
  key: 0,
  class: "bg-white relative border rounded-lg font-gotham"
}
const _hoisted_9 = { class: "w-full text-sm text-left text-gray-500" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-200" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }, "Ref. Base"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }, "ID Trámite"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }, "Trámite"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }, "Fase"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }, "Id Solicitante"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }, "Solicitante"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }, "Fecha llegada"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }, "Fecha vencimiento"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" }, "Detalle"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" })
  ])
], -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "px-4 py-3" }
const _hoisted_13 = {
  key: 0,
  class: "text-red-500 cursor-pointer",
  title: "VENCIDA"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "10",
    cy: "10",
    r: "8"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "text-yellow-500 cursor-pointer",
  title: "POR VENCER"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "10",
    cy: "10",
    r: "8"
  })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "text-green-500 cursor-pointer",
  title: "A TIEMPO"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "10",
    cy: "10",
    r: "8"
  })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "px-4 py-3 font-medium text-gray-900" }
const _hoisted_23 = { class: "px-4 py-3 font-medium text-gray-900" }
const _hoisted_24 = { class: "px-4 py-3 font-medium text-gray-900" }
const _hoisted_25 = { class: "px-4 py-3 font-medium text-gray-900" }
const _hoisted_26 = { class: "px-4 py-3 font-medium text-gray-900" }
const _hoisted_27 = { class: "px-4 py-3 font-medium text-gray-900" }
const _hoisted_28 = { class: "px-4 py-3 font-medium text-gray-900" }
const _hoisted_29 = { class: "px-4 py-3 font-medium text-gray-900" }
const _hoisted_30 = { class: "px-4 py-3 font-medium text-gray-900" }
const _hoisted_31 = { class: "px-4 py-3 w-10" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
  })
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "flex items-center justify-between p-4 border-t" }
const _hoisted_36 = { class: "text-sm text-gray-600" }
const _hoisted_37 = { class: "flex space-x-2" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  class: "bg-white relative border rounded-lg font-gotham p-12"
}
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center space-y-6\" data-v-38bba665><div class=\"flex justify-center\" data-v-38bba665><svg class=\"w-24 h-24 animate-spin\" viewBox=\"0 0 24 24\" data-v-38bba665><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\" fill=\"none\" data-v-38bba665></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\" data-v-38bba665><animateTransform attributeName=\"transform\" attributeType=\"XML\" type=\"rotate\" from=\"0 12 12\" to=\"360 12 12\" dur=\"1s\" repeatCount=\"indefinite\" data-v-38bba665></animateTransform></path></svg></div><h2 class=\"text-3xl font-bold text-gray-800\" data-v-38bba665>Cargando tareas...</h2><div class=\"h-2 w-60 mx-auto bg-gray-200 rounded-full overflow-hidden\" data-v-38bba665><div class=\"h-full bg-gradient-to-r from-[#45a4c9] to-[#6baa19] animate-pulse\" data-v-38bba665></div></div></div>", 1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 2,
  class: "bg-white relative border rounded-lg font-gotham p-12"
}
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center space-y-6\" data-v-38bba665><div class=\"flex justify-center\" data-v-38bba665><svg class=\"w-24 h-24 text-green-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-38bba665><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\" data-v-38bba665></path></svg></div><h2 class=\"text-3xl font-bold text-gray-800\" data-v-38bba665>¡Estás al día!</h2><p class=\"text-xl text-gray-600\" data-v-38bba665>No tienes tareas asignadas en este momento</p></div>", 1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 3,
  class: "bg-white relative border rounded-lg font-gotham p-12"
}
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center space-y-6\" data-v-38bba665><div class=\"flex justify-center\" data-v-38bba665><svg class=\"w-24 h-24 text-red-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-38bba665><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 9v2m0 4h.01M21 20H3l9-16 9 16z\" data-v-38bba665></path></svg></div><h2 class=\"text-3xl font-bold text-gray-800\" data-v-38bba665>¡Ha Ocurrido un Error!</h2><p class=\"text-xl text-gray-600\" data-v-38bba665>Favor contactar a soporte</p></div>", 1)
const _hoisted_52 = [
  _hoisted_51
]

import { computed, ref, /**onMounted, onUnmounted,**/ watch } from 'vue';
import ITask from '@/interfaces/ITask'
import ICountTaskByProcess from '@/interfaces/ICountTaskByProcess'
import SearchForm from './SearchForm.vue';
import config from '@/config/config';
import DateRangePicker from './DateRangePicker.vue';
import StatusFilter from './StatusFilter.vue';
import TaskStatusList from './TaskStatusList.vue';
import ChartByProcess from './ChartByProcess.vue';
import ApiService from '@/services/ApiService'
import TaskDetail from './TaskDetail.vue';

interface DateRange {
    startDate: Date | null;
    endDate: Date | null;
}

const itemsPerPage = 10;


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
    items: {
        type: Array as () => Array<ITask>,
        required: true
    },
    countTaskByProcess: {
        type: Array as () => Array<ICountTaskByProcess>,
        required: true
    },
    userdata: {
        type: String,
        required: true
    },
    loading: {
        type: Boolean,
        required: true
    },
    hasError: {
        type: Boolean,
        required: true,
    }
},
  emits: ["update:status"],
  setup(__props, { emit: __emit }) {

const service = new ApiService()
const filtro = ref('');
const radioFilter = ref('');
const filtroEstados = ref<string[]>([]);
const statusFilter = ref('Pending');
const amountOfTasks = ref<number>(0);

const props = __props

const dateRange = ref<DateRange>({
    startDate: null,
    endDate: null
});

const resultadosFiltrados = computed(() => {
    let items = props.items;

    switch (radioFilter.value) {
        case 'VUI':
            items = items.filter(item => item.project && item.project.toLowerCase().includes('vui'))
            break;
        case 'SISTEMAS':
            items = items.filter(item => item.project && item.project.toLowerCase().includes('sistemas'))
            break;
        default:
            break;
    }

    if (dateRange.value.startDate && dateRange.value.endDate) {
        items = items.filter(item => {
            const itemDate = new Date(item.arrivalDate ?? new Date());
            const endDate = new Date(dateRange.value.endDate!);
            endDate.setHours(23, 59, 59, 999);
            
            return itemDate >= dateRange.value.startDate! && 
                   itemDate <= endDate;
        });
    }

    if (filtroEstados.value.length === 1 && filtroEstados.value[0] !== 'Vencidas') {
        items = items.filter(item => item.statusName && (filtroEstados.value.includes(item.statusName) || filtroEstados.value.length === 0));
    }

    if (filtroEstados.value.includes('Vencidas')) {
        items = items.filter(item => comprobarVencimiento(item.deadline ?? new Date()));
    }

    if (filtro.value !== '') {
        items = items.filter(item => 
            item.processClassName && item.processClassName.toLowerCase().includes(filtro.value.toLowerCase()) || 
            item.processBaseReference && item.processBaseReference.toLowerCase().includes(filtro.value.toLowerCase()) || 
            item.processTheme1 && item.processTheme1.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.processTheme2 && item.processTheme2.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.processTheme3 && item.processTheme3.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.processTheme4 && item.processTheme4.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.processTheme5 && item.processTheme5.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.project && item.project.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()))
    }

    return items;
})

const handleDateRangeChange = (newDateRange: DateRange) => {
    dateRange.value = newDateRange;
};

const administrarBusqueda = (value: string) => 
{
    filtro.value = value;
}

const abrirTareaNuevaPestanna = (taskId: number, origen: string) => {
    const url = origen === 'VUI' 
        ? `${config.urls.vuiTaskUrl}?id=${taskId}&userdata=${props.userdata}` 
        : `${config.urls.sistemasTaskUrl}?id=${taskId}&userdata=${props.userdata}`;

    window.open(url, '_blank');
}

const formatFecha = (date: Date) => {
    const fecha = new Date(date);
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const anio = fecha.getFullYear();
    // if fecha  is 1/1/1900 return empty string
    return dia === 1 && mes === 1 && anio === 1900 ? "" : `${dia}/${mes}/${anio}`;
}

const comprobarVencimiento = (date: Date) => {
    const fecha = new Date(date);
    const hoy = new Date();
    const casiVencida = new Date(fecha);
    casiVencida.setDate(casiVencida.getDate() - 1);

    if (fecha.getDate() === 1 && fecha.getMonth() === 0 && fecha.getFullYear() === 1900){
        return "en_tiempo";
    }

    if (fecha < hoy){
        return "vencida";
    } else if (casiVencida <= hoy){
        return "casi_vencida";
    } else {
        return "en_tiempo";
    }
}

const emit = __emit

const handleStatusChange = (newStatus: string) => {
    statusFilter.value = newStatus;
    emit('update:status', newStatus);
};

const recargarPagina = () => {
    window.location.reload();
}

/* No se sabe porqué está comentado.  */
/** 
let intervalId: number;

onMounted(async () => {
    intervalId = setInterval(async () => {
        await service.setAmountOfTasks(props.userdata, statusFilter.value);
        amountOfTasks.value = await service.getAmountOfTasks().value;
    }, 60000);
});

onUnmounted(() => {
    clearInterval(intervalId);
});
**/

const showOverlay = ref(false);
const selectedItem = ref<ITask | null>(null);

const mostrarDetalle = (item: ITask) => {
    selectedItem.value = item;
    showOverlay.value = true;
}

const currentPage = ref(1);
const totalPages = computed(() => {
    return Math.ceil(resultadosFiltrados.value.length / itemsPerPage);
});

const startIndex = computed(() => (currentPage.value - 1) * itemsPerPage);

const endIndex = computed(() => {
    return Math.min(startIndex.value + itemsPerPage, resultadosFiltrados.value.length);
});

const paginatedItems = computed(() => {
    const items = resultadosFiltrados.value;
    const start = (currentPage.value - 1) * itemsPerPage;
    const end = Math.min(start + itemsPerPage, items.length);
    
    const slicedItems = items.slice(start, end);
    
    return slicedItems;
});

watch([() => resultadosFiltrados.value.length], () => {
    const maxPage = Math.max(1, totalPages.value);
    if (currentPage.value > maxPage) {
        currentPage.value = maxPage;
    }
});

watch([filtro, radioFilter, filtroEstados, dateRange], () => {
    currentPage.value = 1;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TaskStatusList, {
        class: "w-1/2 h-[225px]",
        items: resultadosFiltrados.value
      }, null, 8, ["items"]),
      _createVNode(ChartByProcess, {
        class: "w-1/2 h-[225px]",
        items: props.countTaskByProcess
      }, null, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SearchForm, { onBuscar: administrarBusqueda }),
          _createVNode(DateRangePicker, { "onUpdate:dateRange": handleDateRangeChange }),
          _createVNode(StatusFilter, { "onUpdate:status": handleStatusChange })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: recargarPagina,
            class: "inline-flex items-center px-2 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200 relative",
            title: "Recargar datos"
          }, [
            _hoisted_6,
            (amountOfTasks.value > props.items.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(amountOfTasks.value - props.items.length), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (props.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedItems.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `${item.taskId}-${currentPage.value}-${index}`,
                  class: "border-b",
                  onClick: ($event: any) => (abrirTareaNuevaPestanna(item.taskId ?? 0, item.project ?? 'VUI'))
                }, [
                  _createElementVNode("td", _hoisted_12, [
                    (comprobarVencimiento(item.deadline ?? new Date()) == 'vencida')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_15))
                      : (comprobarVencimiento(item.deadline ?? new Date()) == 'casi_vencida')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_18))
                        : (comprobarVencimiento(item.deadline ?? new Date()) == 'en_tiempo')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21))
                          : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(item.processBaseReference), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(item.processTheme1), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(item.processClassName), 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(item.processTheme2), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(item.processTheme3), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(item.processTheme4), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(formatFecha(item.arrivalDate ?? new Date())), 1),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(formatFecha(item.deadline ?? new Date())), 1),
                  _createElementVNode("td", _hoisted_30, _toDisplayString(item.processTheme5), 1),
                  _createElementVNode("td", _hoisted_31, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (mostrarDetalle(item)), ["stop"]),
                      class: "text-gray-500 hover:text-gray-700",
                      title: "Ver detalles"
                    }, _hoisted_34, 8, _hoisted_32)
                  ])
                ], 8, _hoisted_11))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, " Mostrando " + _toDisplayString(startIndex.value + 1) + " - " + _toDisplayString(endIndex.value) + " de " + _toDisplayString(resultadosFiltrados.value.length) + " resultados ", 1),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (currentPage.value--)),
                disabled: currentPage.value === 1,
                class: "px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50",
                title: "Anterior"
              }, _hoisted_40, 8, _hoisted_38),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value++)),
                disabled: currentPage.value >= totalPages.value,
                class: "px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50",
                title: "Siguiente"
              }, _hoisted_43, 8, _hoisted_41)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
      : (props.items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_49))
        : (props.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
          : _createCommentVNode("", true),
    (showOverlay.value)
      ? (_openBlock(), _createBlock(TaskDetail, {
          key: 4,
          task: selectedItem.value!,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showOverlay.value = false)),
          userData: props.userdata
        }, null, 8, ["task", "userData"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})